import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import apolloProvider from "./apollo-provider";
import { onLogin } from "./vue-apollo";
import { Auth0Plugin } from "./auth";
import Markdown from "./components/Common/Markdown.vue";
import BaseNumeral from "./components/Common/BaseNumeral.vue";

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  },
});

Vue.config.productionTip = false;

Vue.component("Markdown", Markdown);
Vue.component("BaseNumeral", BaseNumeral);

new Vue({
  router,
  vuetify,
  apolloProvider,
  i18n,
  render: (h) => h(App),
  created() {
    this.$auth.$watch("isAuthenticated", async (val) => {
      if (val) {
        onLogin(this.$apolloProvider.defaultClient);
      }
    });
  },
}).$mount("#app");
